<div [class]="classNames + ' mx-auto animate-spin rounded-full overflow-hidden'">
  <img src="https://cdn.chipychapa.com//welle/General_site/Sidebar/Cashier/progress_loader.svg" alt="progress loader" />
</div>
